import {useState} from 'react';
import PropTypes from 'prop-types';
import {Box, Button, createStyles, Dialog, Divider, makeStyles, TextField, Theme, withStyles} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import {useDispatch, useSelector} from 'react-redux';
import {getExperiences, getProjectExperiences, mergeClip, setLoading} from "../../../store/actions";
import {getProjects} from "../../../store/actions/creator/creatorDashboard";
import {PAGINATION_PER_PAGE_ITEM} from "../../../config/mock";
import {addLogToAws} from "../../../config/awslog";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  createBtn: {
    width: 87,
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    fontFamily: 'roboto-regular',
    color: '#fff',
    textTransform: 'none',
    boxShadow: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  cancelBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#e0e0e0',
    },
  },

  label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  description: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    lineHeight: 1.5
  },
  name: {
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color: '#212D40',
    lineHeight: 0.9
  }
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

MergeExperiencesModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selected: PropTypes.any,
  sessionNames: PropTypes.any,
  clearAll: PropTypes.func,
};

MergeExperiencesModal.defaultProps = {
  onClose: () => {
  }
};

function MergeExperiencesModal({ open, onClose, selected, clearAll, ...rest }: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { page } = useSelector((state: any) => state.experience);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [newSessionName, setNewSessionName] = useState("");

  const onChangeNewSessionName = (event:any) => {
    setNewSessionName(event.target.value)
  };

  const onMerge = async () => {
    const requestClipsArr: any = [];
    const clipsData: any = [];
    const userId = parseFloat(loginUserData.user_id);
    
    dispatch(setLoading(true));

    if (selected && selected.length) {
      selected.map((clipdata:any) => {
        if (requestClipsArr[clipdata.session_code]) {
          requestClipsArr[clipdata.session_code].push(clipdata);
        } else {
          requestClipsArr[clipdata.session_code] = [];
          requestClipsArr[clipdata.session_code].push(clipdata);
        }
      });
      
      Object.keys(requestClipsArr).map(function(key: any) {
        clipsData.push({
          session_code: key,
          clips: requestClipsArr[key]
        });
      });
      addLogToAws({ category:'info', method:'MergeExperiencesModal', message:'MergeExperiencesModal', data:({"requestClipArray":requestClipsArr, "clipsData":clipsData})});
    }

    const request = {
      user_id: userId,
      title: newSessionName,
      clips_data: clipsData
    };
    
    dispatch(mergeClip(apolloClient.client, request, () => {
      setTimeout(() => {
        const req = {
          user_id: loginUserData.user_id,
          page_no: 1,
          size: PAGINATION_PER_PAGE_ITEM * page,
          firstpage: true
        };
        dispatch(getExperiences(apolloClient.client, req, null));

        if (!!loginUserData && loginUserData.user_id) {
          const request1 = { projectOwnerId: Number(loginUserData.user_id) };
          dispatch(getProjects(apolloClient.client, request1));
        }

        const projectId: any = localStorage.getItem("projectId");
        if ((projectId) && parseFloat(projectId) != -1) {
          const proReq = {
            project_id: parseFloat(projectId),
          };
          dispatch(getProjectExperiences(apolloClient.client, proReq, null));
        }

        setLoading(false);
      }, 7000);

      clearAll();
      onClose();
      
    }))
  };


  return (
    <Dialog
      
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <div {...rest} >
        <DialogTitle onClose={onClose}>
          Merge Experiences?
        </DialogTitle>
        <Divider />

        <Box m={4} pl={1} pr={1}>
          <p className={classes.description}>
            Are you sure you want to merge the following Experiences?
            <br />
            This operation cannot be undone.
          </p>
        </Box>
        <Box m={4} pl={1} pr={1}>
        <TextField
          label="Experience Name"
          value={newSessionName}
          InputLabelProps={{
            classes: {
              root: classes.label,
              focused: classes.focusedLabel,
              error: classes.erroredLabel
            },
          }}
          InputProps={{
            classes: {
              root: classes.underline,
              // error: classes.error
            }
          }}
          fullWidth
          variant="standard"
          size="small"
          id="newSessionName"
          name="newSessionName"
          onChange={onChangeNewSessionName}
        />
        </Box>
        <Box m={4} pl={1} pr={1}>
          {
            selected.filter((_: any, k: number) => k < 3).map((item: any, index: number) => (
              <>
                <p className={classes.name} key={index}>
                  {item.name ? item.name : item.session_title}
                </p>
              </>
            ))
          }
          {selected.length > 3 && <p className={classes.name}>
            + {selected.length - 3} more...
          </p>}
          
          
        </Box>

        <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
          <Button onClick={onClose} className={classes.cancelBtn}>
            Cancel
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button className={classes.createBtn} onClick={onMerge}>
            Merge
            {/* {loading ? <Loading style={{ width: 60, height: 30, marginTop: -20 }} /> : 'Merge'} */}
          </Button>
        </Box>
      </div>
    </Dialog>
  );
}

export default MergeExperiencesModal;